export const getSelectedCustomer = (state) => state.customers?.selectedCustomer;
